// @flow
import React from 'react';
import { compose } from 'redux';

import SignupComponent from '../components/common/Signup';

import chromeComponent from '../hoc/chromeComponent';

import trackedViewComponent from '../hoc/trackedViewComponent';

import { CHROME_CLEAN_LINKS, META_TITLE_PREFIX } from '../constants';
import { selectSubscriptionFromId } from '../selectors/subscriptionOffer';
import { connect } from 'react-redux';
import { defineMessages } from 'react-intl';
import protectedComponent from '../hoc/protectedComponent';
import * as clientActions from '../actions/client';

const messages = defineMessages({
  metaTitle: {
    id: 'signup.meta-title',
    defaultMessage: 'Create account',
  },
});

type OwnProps = {};

type MapStateToProps = {
  fromId: string,
};

type Props = OwnProps & MapStateToProps;

const Signup = ({ fromId }: Props) => {
  return (
    <div className="u-page-container">
      <SignupComponent fromId={fromId} />
    </div>
  );
};

Signup.onDataFetch = (store, params, location, intl) => {
  store.dispatch(
    clientActions.setHelmet({
      title: META_TITLE_PREFIX + intl.formatMessage(messages.metaTitle),
      canonicalRoute: '/join',
    })
  );
};

const trackingProps = state => {
  return {
    landing_page_id: selectSubscriptionFromId(state),
  };
};

function mapStateToProps(state: Object): MapStateToProps {
  return {
    fromId: selectSubscriptionFromId(state),
  };
}

export default compose(
  protectedComponent({ anonymousOnly: true }),
  connect(mapStateToProps),
  trackedViewComponent('Signup', trackingProps),
  chromeComponent({ type: CHROME_CLEAN_LINKS })
)(Signup);
